export const storyData = [
  {
    name: "Hwanhee (Hilary) Yoon",
    description: "High School Student",
    quote:
      "My family and I feel American, and I grew up just like our American neighbors around us.",
    link: "https://www.improvethedream.org/hilarystory",
    image: require("../assets/story/Hilary.jpg"),
  },
  {
    name: "Pareen Mhatre",
    description: "Biomedical Engineering, University of Iowa",
    quote:
      "I just want to feel some sort of security in the home I grew up in.",
    link: "https://www.improvethedream.org/pareenstory",
    image: require("../assets/story/Pareen.jpg"),
  },
  {
    name: "Anagh Kulkarni",
    description: "Biomedical Science, Ohio State University",
    quote:
      "There are many who are in the same situation as me, who are here and just want to contribute back to the United States.",
    link: "https://www.improvethedream.org/anaghstory",
    image: require("../assets/story/Anagh.jpg"),
  },
  {
    name: "Padma Danturty",
    description: "High School Student",
    quote:
      "I hope one day I can truly call the only country I've ever known home.",
    link: "https://www.improvethedream.org/padmastory",
    image: require("../assets/story/Padma.jpg"),
  },
  {
    name: "Lakshmi Parvathinathan",
    description: "Biological Sciences, Drexel University",
    quote:
      "We just want to be given a real chance to chase our American Dream.",
    link: "https://www.improvethedream.org/lakshmistory",
    image: require("../assets/story/Lakshmi.jpg"),
  },
  {
    name: "Sanjana Mupparaju",
    description: "High School Student",
    quote:
      "I understand that my financial independence, security, and my place in this country are not protected.",
    link: "https://www.improvethedream.org/sanjanastory",
    image: require("../assets/story/Sanjana.jpg"),
  },
];

export default storyData;
